<template>
    <div>

        <el-form label-position="top">

            <el-tabs type="border-card" v-model="tabAtivo">
                <el-tab-pane label="FILTROS" name="filtros">

                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Instituição" key="instituicao" v-if="([4, 5, 6, 7, 8, 10, 11].includes(Number($store.state.user.tipo)))">
                                    <el-select ref="instituicao_id" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable>
                                        <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <div class="style-form" v-if="[0, 1, 3, 9, 12].includes(Number(this.$store.state.user.tipo))">
                                    <label>Instituição</label>
                                    <div class="style-input readonly">{{ $store.state.config.instituicao.nome }}</div>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="6" :md="6">
                                <el-form-item label="Período" key="periodo">
                                    <el-select ref="periodo_letivo_id" v-model="filtro.periodo_letivo_id">
                                        <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="6" :md="6">
                                <el-form-item label="Consolidado por" key="consolidado">
                                    <el-select ref="consolidado" v-model="filtro.consolidado">
                                        <el-option :key="1" label="ZONA E INSTITUIÇÃO" :value="1"></el-option>
                                        <el-option :key="2" label="ZONA E CURSO (QUANTITATIVO)" :value="2"></el-option>

                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Situação" prop="situacao" key="situacao">
                                    <el-select ref="situacao" v-model="filtro.situacao" clearable multiple>
                                        <el-option v-for="(item, i) in $CONSTANTS.SITUACAO_TURMA" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Turno" prop="turno" key="turno">
                                    <el-select ref="turno" v-model="filtro.turno" clearable filterable multiple>
                                        <el-option v-for="(item, i) in $CONSTANTS.TURNO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Local diferenciado?" prop="local_diferenciado" key="local_diferenciado">
                                    <el-select ref="local_diferenciado" v-model="filtro.local_diferenciado" clearable multiple>
                                        <el-option v-for="(item, i) in $CONSTANTS.SALA_LOCAL_DIFERENCIADO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Tipo de Ensino" prop="tipo_ensino" key="tipo_ensino">
                                    <el-select ref="tipo_ensino" v-model="filtro.tipo_ensino" clearable multiple>
                                        <el-option v-for="(item, i) in $CONSTANTS.TIPO_ENSINO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Curso (s)" prop="cursos" key="cursos">
                                    <el-select ref="curso" v-model="filtro.curso" filterable clearable multiple>
                                        <el-option v-for="(item, i) in selectCursos" :key="i" :label="item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                </el-tab-pane>
                <el-tab-pane label="CAMPOS" name="campos">

                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <label class="u-pl-5 u-mb-5" style="display: block; font-size: 15px;"><b>Campos de Turma</b></label>
                                <div style="height: 260px; background-color: #f8f8f8; padding:10px;">
                                    <el-checkbox-group v-model="campos.turma" class="checkbox-filtos">
                                        <el-checkbox label="nome">Nome da Turma</el-checkbox>
                                        <el-checkbox label="instituicao">Instituição</el-checkbox>
                                        <el-checkbox label="turno">Turno</el-checkbox>
                                        <el-checkbox label="local_diferenciado">Local Diferenciado</el-checkbox>
                                        <el-checkbox label="qtd_vagas_iniciais">Quantidade de Vagas Iniciais</el-checkbox>
                                        <el-checkbox label="qtd_alunos_matriculados">Quantidade de Alunos Matriculados</el-checkbox>
                                        <el-checkbox label="qtd_vagas_disponiveis">Quantidade de Vagas Disponíveis</el-checkbox>
                                        <el-checkbox label="situacao">Situação</el-checkbox>
                                        <el-checkbox label="tipo_ensino">Tipo de Ensino</el-checkbox>
                                        <el-checkbox label="horario_inicial_funcionamento">Horário Início de Funcionamento</el-checkbox>
                                        <el-checkbox label="horario_final_funcionamento">Horário Final de Funcionamento</el-checkbox>
                                        <el-checkbox label="data_abertura">Data Abertura</el-checkbox>
                                        <el-checkbox label="data_conclusao">Data Conclusão</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </el-col>
                        </el-row>


                </el-tab-pane>
            </el-tabs>

            <div class="u-mt-10">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                        <!-- <el-button @click="getDadosRelatorioGeralTurma()" type="primary">BUSCAR</el-button>                     -->
                        <el-button @click="renderRelatorioGeralTurma('excel')" :loading="loadingButtonExcel" type="primary">EXCEL</el-button>
                        <el-button @click="renderRelatorioGeralTurma('pdf')" :loading="loadingButtonPdf" type="primary">PDF</el-button>
                        <el-button @click="renderRelatorioGeralTurma('html')" :loading="loadingButtonHtml" type="primary">HTML</el-button>
                    </el-col>
                </el-row>
            </div>


        </el-form>

    </div>
</template>
<script>
import cPanel from '../../../shared/c-panel/c-panel.vue';

export default {
  components: { cPanel },
    data: () => ({
        tabAtivo: 'filtros',
        loadingButtonExcel: false,
        loadingButtonPdf: false,
        loadingButtonHtml: false,
        statusList: true,
        ref: [],
        campos:{
            turma: [
                'nome',
                'turno',
                'local_diferenciado',
                'qtd_vagas_iniciais',
                'qtd_alunos_matriculados',
                'qtd_vagas_disponiveis'
            ]
        },
        filtro: {
            instituicao_id: '',
            periodo_letivo_id: '',
            situacao: [1],
            turno: '',
            local_diferenciado: '',
            tipo_ensino: [1, 2],
            curso: '',
            consolidado: 1
        },
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        itens: [ ],
        selectCursos: []

    }),
    mounted () {

        this.filtro.periodo_letivo_id = this.$store.state.config.periodo.id;

        if([0, 1, 3, 9, 12].includes(Number(this.$store.state.user.tipo))){

            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
        }

        this.getAllCursos();
    },
    methods: {

        renderRelatorioGeralTurma(tipo){

            if(this.campos.turma.length == 0){

                window.eventBus.$emit('alert', {msg: 'É necessário selecionar, pelo menos, um campo a ser apresentado no relatório.', type: 'warning'});
                return false;
            }

            this.ref = [
                { nome: 'Instituição', valor: (([0, 1, 3, 9, 12].includes(Number(this.$store.state.user.tipo))) ? this.$store.state.config.instituicao.nome : this.$refs.instituicao_id.selected.label) },
                { nome: 'Período Letivo', valor: this.$refs.periodo_letivo_id.selected.label },
                { nome: 'Consolidado', valor: this.$refs.consolidado.selected.label },
                // { nome: 'Turno', valor: this.$refs.turno.selected.label },
                // { nome: 'Local Diferenciado', valor: this.$refs.local_diferenciado.selected.label },
                // { nome: 'Local Diferenciado', valor: this.$refs.tipo_ensino.selected.label },
                // { nome: 'Curso', valor: this.$refs.curso.selected.label },
            ];

            if(this.$refs.situacao.selected.length > 0){
                this.addMultipleSelectFieldToRefFilter('Situação', this.$refs.situacao.selected);
            }

            if(this.$refs.turno.selected.length > 0){
                this.addMultipleSelectFieldToRefFilter('Turno', this.$refs.turno.selected);
            }

            if(this.$refs.local_diferenciado.selected.length > 0){
                this.addMultipleSelectFieldToRefFilter('Local Diferenciado', this.$refs.local_diferenciado.selected);
            }

            if(this.$refs.curso.selected.length > 0){
                this.addMultipleSelectFieldToRefFilter('Curso', this.$refs.curso.selected);
            }

            if(tipo == 'pdf'){

                this.loadingButtonPdf = true;
                this.renderPdfRelatorioGeralTurma();

            }else if(tipo == 'html'){

                this.loadingButtonHtml = true;
                this.renderHtmlRelatorioGeralTurma();

            }else if(tipo == 'excel'){

                this.loadingButtonExcel = true;
                this.renderExcelRelatorioGeralTurma();
            }
        },
        renderPdfRelatorioGeralTurma(){

            window.eventBus.$emit('print', {url: '/api/pdf/renderRelatorioGeralTurma/pdf', param: {ref: this.ref, filtros: this.filtro, campos: this.campos}});
            this.loadingButtonPdf = false;
        },
        renderExcelRelatorioGeralTurma(){

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioGeralTurma/excel`, { param: {ref: this.ref, filtros: this.filtro, campos: this.campos} }, this.$store.getters.getHeaderAuthExcel).then(response => {

                this.loadingButtonExcel = false;

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'relatorio.xlsx');
                document.body.appendChild(link);
                link.click();

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        async renderHtmlRelatorioGeralTurma(){

            try{

                let response = await this.getCodAutorizacaoRelatorioHtml();

                window.open(`${process.env.VUE_APP_BASE_URL}/api/relatorio/open/${response.data.token}`);

                this.loadingButtonHtml = false;

            }catch(e){

                window.eventBus.$emit('alert', {msg: 'Erro ao gerar relatório.', type: 'warning'});
            }

        },
        getCodAutorizacaoRelatorioHtml(){

            return this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/relatorio/generateCodAutorizacaoPrintHtml/geral-turmas`, {ref: this.ref, filtros: this.filtro, campos: this.campos}, this.$store.getters.getHeaderAuth);
        },
        getAllCursos(){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/curso/getAllCurso`, this.$store.getters.getHeaderAuth).then(response => {

                this.selectCursos = JSON.parse(JSON.stringify(response.data));

            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        getPagePagination(page){
          this.paginate.page = page;
          this.getDadosRelatorioGeralTurma();
        },
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA

            if(!this.filtro[field])
                return false;

            if(size && this.filtro[field].length < size)
                this.filtro[field] = '';

            this.filtro[field] = this.filtro[field].toUpperCase();

            this.filtro[field] = this.$removerAcentos(this.filtro[field]);
        },
        getSelected(v){

            let t = '';
            for(let i in v){

                t += ' ' + v[i].label;
            }
            return t;
        },
        addMultipleSelectFieldToRefFilter(name, valuesSelected){
            const temp = { nome: name, valor: [] }
            valuesSelected.forEach(element => {
                temp.valor.push(element.currentLabel);
            });
            this.ref.push(temp);
        }
    }
}
</script>